import { GeoJSONFeatureCollection } from 'ol/format/GeoJSON';
import { DeviceSetStatus } from '../../models/models';
import { Action, ActionWithPayload, createAction, withMatcher } from '../../utils/reducer/reducer.utils';
import { DEVICESET_ACTION_TYPES } from './deviceset.types';

export type GetDevicesetsStart = ActionWithPayload<
    DEVICESET_ACTION_TYPES.GET_DEVICESETS_START, {
        devicesetId: string | null;
        onComplete: (devicesets: GeoJSONFeatureCollection) => void;
    }
>;

export type GetDevicesetsSuccess = Action<
    DEVICESET_ACTION_TYPES.GET_DEVICESETS_SUCCESS
>;

export type GetDevicesetsFailed = ActionWithPayload<
    DEVICESET_ACTION_TYPES.GET_DEVICESETS_FAILED,
    string
>;

export type GetDevicesetsStatusStart = ActionWithPayload<
    DEVICESET_ACTION_TYPES.GET_DEVICESETS_STATUS_START,
    {
        devicesetId: string | null;
        onComplete: (status: DeviceSetStatus) => void;
    }
>;

export type GetDevicesetsStatusSuccess = Action<
    DEVICESET_ACTION_TYPES.GET_DEVICESETS_STATUS_SUCCESS
>;

export type GetDevicesetsStatusFailed = ActionWithPayload<
    DEVICESET_ACTION_TYPES.GET_DEVICESETS_STATUS_FAILED,
    string
>;

export const getDevicesetsStart = withMatcher(
    (devicesetId: string | null, onComplete: (devicesets: GeoJSONFeatureCollection) => void): GetDevicesetsStart =>
        createAction(DEVICESET_ACTION_TYPES.GET_DEVICESETS_START, { devicesetId, onComplete })
);

export const getDevicesetsSuccess = withMatcher(
    (): GetDevicesetsSuccess =>
        createAction(DEVICESET_ACTION_TYPES.GET_DEVICESETS_SUCCESS)
);

export const getDevicesetsFailed = withMatcher(
    (error: string): GetDevicesetsFailed =>
        createAction(DEVICESET_ACTION_TYPES.GET_DEVICESETS_FAILED, error)
);

export const getDevicesetsStatusStart = withMatcher(
    (devicesetId: string | null, onComplete: (status: DeviceSetStatus) => void): GetDevicesetsStatusStart =>
        createAction(DEVICESET_ACTION_TYPES.GET_DEVICESETS_STATUS_START, { devicesetId, onComplete })
);

export const getDevicesetsStatusSuccess = withMatcher(
    (): GetDevicesetsStatusSuccess =>
        createAction(DEVICESET_ACTION_TYPES.GET_DEVICESETS_STATUS_SUCCESS)
);

export const getDevicesetsStatusFailed = withMatcher(
    (error: string): GetDevicesetsStatusFailed =>
        createAction(DEVICESET_ACTION_TYPES.GET_DEVICESETS_STATUS_FAILED, error)
);